"use client";

import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const GradientColors = ({ colors = {
    start: "#18CCFC",
    middle: "#6344F5",
    end: "#AE48FF"
} }) => {
    return (
        <>
            <stop offset="0%" stopColor={colors.start} stopOpacity="0" />
            <stop offset="20%" stopColor={colors.start} stopOpacity="1" />
            <stop offset="50%" stopColor={colors.middle} stopOpacity="1" />
            <stop offset="100%" stopColor={colors.end} stopOpacity="0" />
        </>
    );
};

export const AgenticButton = ({ onClick, className }) => {
    // Beams configured to trace the border of a button
    // We'll use a fixed size for the SVG to ensure path continuity, but scale the container
    const width = 140;
    const height = 40;
    const path = `M2 2 H${width - 2} V${height - 2} H2 Z`; // Rectangle path

    const beam = {
        path: path,
        gradientConfig: {
            initial: { x1: "0%", x2: "0%", y1: "0%", y2: "0%" },
            animate: {
                x1: ["0%", "100%", "0%"],
                x2: ["0%", "100%", "0%"],
                y1: ["0%", "0%", "0%"],
                y2: ["0%", "0%", "0%"],
            },
            transition: {
                duration: 2,
                repeat: Infinity,
                ease: "linear",
            }
        }
    };

    return (
        <button
            onClick={onClick}
            className={cn(
                "relative flex items-center justify-center px-4 py-2 bg-transparent text-sm font-medium transition-colors group",
                "text-violet-700 dark:text-violet-300",
                className
            )}
        >
            {/* Background with slight tint */}
            <div className="absolute inset-0 bg-violet-100/50 dark:bg-violet-900/10 rounded-md -z-10" />

            {/* SVG Container for the Beam Border */}
            <div className="absolute inset-0 pointer-events-none rounded-md overflow-hidden">
                <svg
                    width="100%"
                    height="100%"
                    viewBox={`0 0 ${width} ${height}`}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                >
                    {/* Base Border */}
                    <path
                        d={path}
                        stroke="var(--violet-200)"
                        strokeWidth="1"
                        vectorEffect="non-scaling-stroke"
                        className="dark:stroke-violet-800"
                    />

                    {/* Animated Beam */}
                    <motion.path
                        d={path}
                        stroke="url(#beam-gradient)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        vectorEffect="non-scaling-stroke"
                        initial={{ pathLength: 0, opacity: 0 }}
                        animate={{ pathLength: 1, opacity: 1, strokeDasharray: "20 150", strokeDashoffset: [0, -300] }}
                        transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                    />

                    <defs>
                        <linearGradient id="beam-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <GradientColors />
                        </linearGradient>
                    </defs>
                </svg>
            </div>

            <span className="relative z-10 flex items-center gap-2">
                Agentic Mode
            </span>
        </button>
    );
};
